import { useLanguage } from '../../../contexts/useLanguage';
import comicImg from '../../../assets/readdy/c68c3805101cef8f4cbc2f3bdfdb9005__1ea04b5274.png';
import petImg from '../../../assets/readdy/e4ebfad7828b30c342fb50b6708f6bd8__50717e0a8e.png';

export default function Products() {
  const { t } = useLanguage();

  const products = [
    {
      title: t('AI漫画生成器', 'AI Comic Generator'),
      description: t(
        '基于先进的AI技术，将文字描述转化为精美的漫画作品。支持多种风格，让创作变得简单有趣。',
        'Based on advanced AI technology, transform text descriptions into beautiful comic works. Support multiple styles and make creation simple and fun.'
      ),
      image: comicImg,
      color: 'from-purple-500 to-pink-500',
      link: '/aicomic'
    },
    {
      title: t('AI治愈宠物', 'AI Healing Pet'),
      description: t(
        'AI技术驱动的虚拟宠物陪伴系统，提供情感支持和心理疏导，让每个人都能拥有温暖的陪伴',
        'Virtual pet companion system powered by AI technology, providing emotional support and psychological counseling, bringing warm companionship to everyone.'
      ),
      image: petImg,
      color: 'from-pink-500 to-rose-500',
      link: '/emotional-ai'
    }
  ];

  return (
    <section id="products" className="py-20 px-6 bg-gray-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('我们的产品', 'Our Products')}</h2>
          <p className="text-xl text-gray-600">{t('创新AI技术，赋能美好生活', 'Innovative AI Technology, Empowering Better Life')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {products.map((product, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col"
            >
              <div className="h-[600px] bg-white flex items-center justify-center p-8">
                <img 
                  src={product.image} 
                  alt={product.title}
                  className="w-full h-full object-contain"
                />
              </div>
              
              <div className="p-8 flex-1 flex flex-col">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{product.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6 flex-1">{product.description}</p>
                
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE(product.link)}
                  className="inline-flex items-center justify-center px-8 py-3 bg-gray-900 text-white font-medium rounded-full hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer w-full"
                >
                  {t('了解更多', 'Learn More')}
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
